import { gql } from '@apollo/client';

export const EXPORT_SCHOOL_PROMOTION = gql`
  query ExportSchoolPromotion($input: ExportArgs!) {
    exportSchoolPromotion(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      schoolPromotionData {
        id
        circuit {
          id
          name
        }
        emisNumber
        grade {
          id
          name
          value
        }
        district {
          id
          name
        }
        gradeAverage
        numberEnrolled
        numberPassed
        numberWrote
        percentagePassed
        promotionStatus {
          name
        }
        term
        year
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
